<template>
  <div class="qr-page">

    <!-- ─── Encabezado: barra sticky que se encoge al hacer scroll ─── -->
    <div class="qr-page-header" :class="{ 'qr-page-header--scrolled': headerScrolled }">
      <div class="qr-page-header-inner">
        <button class="qr-back-btn" aria-label="Regresar al Taller Creativo"
          @click="$router.push({ path: '/', hash: '#taller-creativo' })">
          <i class="fas fa-arrow-left"></i>
        </button>
        <div class="qr-page-title-area">
          <h1 class="qr-page-heading">Generador de QR</h1>
          <p class="qr-page-desc">Crea códigos QR personalizados al instante para tu negocio, redes sociales o cualquier uso que necesites.</p>
        </div>
        <span class="qr-page-chip"><i class="fas fa-wand-magic"></i> Taller Creativo</span>
      </div>
    </div>

    <div class="qr-body-wrap">
    <div class="qr-page-body">
      <div class="qr-layout">

        <!-- ─── Panel Configuración ─── -->
        <div class="qr-panel">
          <h2 class="qr-panel-title">Configurador Neliel</h2>

          <!-- Dimensiones -->
          <div class="qr-block">
            <div class="qr-row">
              <div class="qr-field">
                <label class="qr-label">Ancho (px)</label>
                <input type="number" v-model.number="cardWidth" min="200" max="600" step="10" class="qr-input qr-input-center">
              </div>
              <div class="qr-field">
                <label class="qr-label">Alto (px)</label>
                <input type="number" v-model.number="cardHeight" min="300" max="800" step="10" class="qr-input qr-input-center">
              </div>
            </div>
          </div>

          <!-- Color header + Estilo QR -->
          <div class="qr-block">
            <div class="qr-row">
              <div class="qr-field">
                <label class="qr-label qr-label-muted">Color Header</label>
                <input type="color" v-model="headerColor" class="qr-color">
              </div>
              <div class="qr-field">
                <label class="qr-label qr-label-muted">Estilo QR</label>
                <select v-model="qrStyle" class="qr-select">
                  <option value="dots">Puntos</option>
                  <option value="rounded">Redondeado</option>
                  <option value="extra-rounded">Cápsulas</option>
                  <option value="classy">Classy</option>
                  <option value="classy-rounded">Classy Redondeado</option>
                  <option value="square">Cuadrado</option>
                </select>
              </div>
            </div>
          </div>

          <!-- Colores QR -->
          <div class="qr-block">
            <div class="qr-row">
              <div class="qr-field">
                <label class="qr-label qr-label-muted">Color Puntos QR</label>
                <input type="color" v-model="qrDotColor" class="qr-color">
              </div>
              <div class="qr-field">
                <label class="qr-label qr-label-muted">Fondo QR</label>
                <input type="color" v-model="qrBgColor" class="qr-color">
              </div>
            </div>
          </div>

          <!-- Logo en QR -->
          <div class="qr-block">
            <label class="qr-label qr-label-muted">Logo en QR</label>
            <label class="qr-checkbox-row">
              <input type="checkbox" v-model="showQrLogo" class="qr-checkbox">
              Agregar logo al centro del QR
            </label>
            <div v-show="showQrLogo" class="qr-file-row">
              <label class="qr-file-label">
                {{ logoLabel }}
                <input type="file" accept="image/*" class="qr-file-hidden" @change="handleLogoUpload">
              </label>
              <button class="qr-reset-btn" @click="resetLogo">Reset</button>
            </div>
          </div>

          <!-- Título y subtítulo -->
          <div class="qr-field">
            <label class="qr-label">Título de la Card</label>
            <input type="text" v-model="cardTitle" placeholder="Ej: Neliel Papelería" class="qr-input">
          </div>
          <div class="qr-field" style="margin-top:12px">
            <label class="qr-label">Subtítulo</label>
            <input type="text" v-model="cardSubtitle" placeholder="Ej: Escanear" class="qr-input">
          </div>

          <!-- Selector de acción -->
          <div class="qr-field" style="margin-top:12px">
            <label class="qr-label">Acción código QR</label>
            <select v-model="action" class="qr-action-select">
              <option v-for="act in ACTIONS" :key="act.value" :value="act.value">{{ act.label }}</option>
            </select>
            <div class="qr-action-icon-row">
              <img :src="currentActionIcon" class="qr-action-icon-preview" alt="Ícono de acción">
              <div style="flex:1">
                <label class="qr-label qr-label-muted" style="margin-bottom:4px;font-size:0.65rem">Ícono personalizado</label>
                <label class="qr-file-label qr-file-label-sm">
                  {{ cardIconLabel }}
                  <input type="file" accept="image/*" class="qr-file-hidden" @change="handleIconUpload">
                </label>
              </div>
              <button class="qr-reset-btn" @click="resetIcon">Reset</button>
            </div>
          </div>

          <!-- Campos dinámicos por tipo de acción -->
          <div class="qr-block">
            <label class="qr-label qr-label-muted">Datos del Código</label>

            <div v-show="action === 'vcard-pro'" class="qr-fields-group">
              <input type="text"  v-model="formData.vName"  placeholder="Nombre Completo" class="qr-input">
              <input type="tel"   v-model="formData.vTel"   placeholder="Teléfono"        class="qr-input">
              <input type="email" v-model="formData.vEmail" placeholder="Email"            class="qr-input">
              <input type="url"   v-model="formData.vUrl"   placeholder="Sitio Web"        class="qr-input">
              <input type="text"  v-model="formData.vDir"   placeholder="Dirección"        class="qr-input">
            </div>

            <div v-show="action === 'url'">
              <input type="text" v-model="formData.url" placeholder="https://neliel.mx" class="qr-input">
            </div>

            <div v-show="action === 'wa'" class="qr-fields-group">
              <input type="tel"  v-model="formData.waNum" placeholder="Número WhatsApp" class="qr-input">
              <input type="text" v-model="formData.waMsg" placeholder="Mensaje inicial"  class="qr-input">
            </div>

            <div v-show="action === 'ig'">
              <input type="text" v-model="formData.ig" placeholder="Usuario Instagram" class="qr-input">
            </div>

            <div v-show="action === 'fb'">
              <input type="text" v-model="formData.fb" placeholder="URL Facebook" class="qr-input">
            </div>

            <div v-show="action === 'wifi'" class="qr-fields-group">
              <input type="text" v-model="formData.wifiSsid" placeholder="Red (SSID)" class="qr-input">
              <input type="text" v-model="formData.wifiPass" placeholder="Contraseña" class="qr-input" v-show="!formData.wifiOpen">
              <label class="qr-checkbox-row">
                <input type="checkbox" v-model="formData.wifiOpen" class="qr-checkbox">
                Red Abierta (Sin contraseña)
              </label>
            </div>

            <div v-show="action === 'phone'">
              <input type="tel" v-model="formData.phone" placeholder="Teléfono" class="qr-input">
            </div>

            <div v-show="action === 'email'" class="qr-fields-group">
              <input type="email" v-model="formData.emailAddr" placeholder="Email"   class="qr-input">
              <input type="text"  v-model="formData.emailSubj" placeholder="Asunto"  class="qr-input">
            </div>

            <div v-show="action === 'maps'">
              <input type="text" v-model="formData.maps" placeholder="Enlace Maps" class="qr-input">
            </div>

            <div v-show="action === 'pay'">
              <input type="text" v-model="formData.pay" placeholder="CLABE / Pago" class="qr-input">
            </div>

            <div v-show="action === 'review'">
              <input type="text" v-model="formData.review" placeholder="Enlace Google Review" class="qr-input">
            </div>
          </div>

          <!-- NFC -->
          <label class="qr-nfc-toggle">
            <input type="checkbox" v-model="enableNfc" class="qr-checkbox">
            Activar NFC
          </label>

          <!-- Solo QR -->
          <label class="qr-nfc-toggle">
            <input type="checkbox" v-model="qrOnly" class="qr-checkbox">
            Solo QR (sin tarjeta)
          </label>
        </div>

        <!-- ─── Preview Tarjeta ─── -->
        <div class="qr-preview-wrap">
          <!-- Botones encima de la tarjeta -->
          <div class="qr-action-bar">
            <span class="qr-action-bar-label" v-if="!isValid">Llena los datos para habilitar</span>
            <div class="qr-action-btns">
              <button class="qr-action-btn qr-action-btn--outline" :disabled="!isValid" @click="downloadSvg">
                <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"/>
                </svg>
                <span>SVG</span>
              </button>
              <button class="qr-action-btn qr-action-btn--outline" :disabled="!isValid" @click="downloadPng">
                <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"/>
                </svg>
                <span>PNG</span>
              </button>
              <button class="qr-action-btn qr-action-btn--primary" @click="doPrint" :disabled="!isValid">
                <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"/>
                </svg>
                <span>Imprimir</span>
              </button>
            </div>
          </div>

          <div class="qr-card-scroll">
          <div
            ref="cardEl"
            class="qr-card"
            :class="{ 'qr-card--bare': qrOnly }"
            :style="qrOnly ? {} : { width: cardWidth + 'px', height: cardHeight + 'px' }"
          >
            <div v-if="!qrOnly" class="qr-card-header" :style="{ backgroundColor: headerColor }"></div>
            <div class="qr-card-body">
              <div v-if="!qrOnly" class="qr-icon-ring">
                <img :src="resolvedIconUrl" class="qr-icon-img" alt="Ícono">
              </div>
              <h3 v-if="!qrOnly" class="qr-card-title">{{ cardTitle || 'NELIEL' }}</h3>
              <span v-if="!qrOnly" class="qr-card-sub">{{ cardSubtitle || 'ESCANEAR' }}</span>
              <div class="qr-frame">
                <span v-if="!isValid" class="qr-warning">!</span>
                <div ref="qrCanvas"></div>
                <img
                  v-if="showQrLogo && !isLogoDataUrl"
                  :src="customLogoUrl"
                  class="qr-logo-overlay"
                  alt="Logo Neliel"
                >
              </div>
              <div v-if="enableNfc && !qrOnly" class="qr-nfc-row">
                <svg style="width:18px;height:18px" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
                  <path d="M9.348 14.651a3.75 3.75 0 010-5.303m5.304 0a3.75 3.75 0 010 5.303m-7.425 2.122a6.75 6.75 0 010-9.546m9.546 0a6.75 6.75 0 010 9.546M5.106 18.894c-3.808-3.807-3.808-9.98 0-13.788m13.788 0c3.808 3.807 3.808 9.98 0 13.788"/>
                </svg>
                <span>NFC</span>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>

    </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, watch, computed, onMounted, onBeforeUnmount } from 'vue'
import QRCodeStyling from 'qr-code-styling'

const DEFAULT_LOGO = 'https://neliel.mx/img/logo_neliel.png'

const ACTIONS = [
  { value: 'vcard-pro', label: 'Tarjeta de Contacto Pro', icon: 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png' },
  { value: 'url',       label: 'Sitio Web / Enlace',       icon: 'https://cdn-icons-png.flaticon.com/512/1006/1006771.png' },
  { value: 'wa',        label: 'WhatsApp',                  icon: 'https://cdn-icons-png.flaticon.com/512/3670/3670051.png' },
  { value: 'ig',        label: 'Instagram',                 icon: 'https://cdn-icons-png.flaticon.com/512/174/174855.png' },
  { value: 'fb',        label: 'Facebook',                  icon: 'https://cdn-icons-png.flaticon.com/512/124/124010.png' },
  { value: 'wifi',      label: 'Conectar WiFi',             icon: 'https://cdn-icons-png.flaticon.com/512/93/93158.png'  },
  { value: 'phone',     label: 'Llamada',                   icon: 'https://cdn-icons-png.flaticon.com/512/597/597177.png' },
  { value: 'email',     label: 'Enviar Correo',             icon: 'https://cdn-icons-png.flaticon.com/512/542/542689.png' },
  { value: 'maps',      label: 'Ubicación (Maps)',          icon: 'https://cdn-icons-png.flaticon.com/512/854/854878.png' },
  { value: 'pay',       label: 'Pagos / CLABE',             icon: 'https://cdn-icons-png.flaticon.com/512/1086/1086741.png' },
  { value: 'review',    label: 'Reseñas / Google',          icon: 'https://cdn-icons-png.flaticon.com/512/1828/1828884.png' },
]

export default {
  name: 'GeneradorQR',
  setup() {
    const headerColor      = ref('#003b4c')
    const qrStyle          = ref('dots')
    const qrDotColor       = ref('#000000')
    const qrBgColor        = ref('#ffffff')
    const cardTitle        = ref('')
    const cardSubtitle     = ref('')
    const action           = ref('vcard-pro')
    const enableNfc        = ref(true)
    const qrOnly           = ref(false)
    const cardWidth        = ref(320)
    const cardHeight       = ref(480)
    const customLogoUrl    = ref(DEFAULT_LOGO)
    const showQrLogo       = ref(false)
    const customCardIconUrl = ref(null)
    const isValid          = ref(false)
    const logoLabel        = ref('Subir imagen')
    const cardIconLabel    = ref('Subir ícono')
    const qrCanvas         = ref(null)
    const cardEl           = ref(null)

    const formData = reactive({
      vName: '', vTel: '', vEmail: '', vUrl: '', vDir: '',
      url: '',
      waNum: '', waMsg: '',
      ig: '',
      fb: '',
      wifiSsid: '', wifiPass: '', wifiOpen: false,
      phone: '',
      emailAddr: '', emailSubj: '',
      maps: '',
      pay: '',
      review: ''
    })

    // Logo por defecto convertido a data URL para que qr-code-styling lo incluya en PNG/SVG
    const defaultLogoData  = ref(null)
    const qrLogoSrc        = computed(() =>
      customLogoUrl.value.startsWith('data:') ? customLogoUrl.value : (defaultLogoData.value || '')
    )
    // true cuando la librería dibuja el logo; si no, se usa el <img> superpuesto como respaldo
    const isLogoDataUrl    = computed(() => !!qrLogoSrc.value)

    async function toDataUrl(url) {
      const blob = await (await fetch(url)).blob()
      return new Promise((resolve, reject) => {
        const r = new FileReader()
        r.onload = () => resolve(r.result)
        r.onerror = reject
        r.readAsDataURL(blob)
      })
    }

    async function loadDefaultLogo() {
      try {
        defaultLogoData.value = await toDataUrl(DEFAULT_LOGO)
      } catch (e) {
        defaultLogoData.value = null // sin CORS: queda el overlay (no saldrá en la descarga)
      }
    }
    const currentActionIcon = computed(() => ACTIONS.find(a => a.value === action.value)?.icon ?? '')
    const resolvedIconUrl  = computed(() => customCardIconUrl.value || currentActionIcon.value)

    let qrCode = null

    function buildQrData() {
      switch (action.value) {
        case 'vcard-pro': {
          const name = formData.vName.trim()
          return name
            ? `BEGIN:VCARD\nVERSION:3.0\nFN:${name}\nTEL:${formData.vTel}\nEMAIL:${formData.vEmail}\nURL:${formData.vUrl}\nADR:;;${formData.vDir}\nEND:VCARD`
            : ''
        }
        case 'url': return formData.url.trim()
        case 'wa': {
          const num = formData.waNum.replace(/\D/g, '')
          return num ? `https://wa.me/${num}?text=${encodeURIComponent(formData.waMsg)}` : ''
        }
        case 'ig': {
          const u = formData.ig.replace(/^@/, '').trim()
          return u ? `https://instagram.com/${u}` : ''
        }
        case 'fb': return formData.fb.trim()
        case 'wifi': {
          const ssid = formData.wifiSsid.trim()
          if (!ssid) return ''
          return formData.wifiOpen
            ? `WIFI:T:nopass;S:${ssid};P:;;`
            : `WIFI:T:WPA;S:${ssid};P:${formData.wifiPass};;`
        }
        case 'phone': {
          const t = formData.phone.trim()
          return t ? `tel:${t}` : ''
        }
        case 'email': {
          const e = formData.emailAddr.trim()
          return e ? `mailto:${e}?subject=${encodeURIComponent(formData.emailSubj)}` : ''
        }
        case 'maps':   return formData.maps.trim()
        case 'pay':    return formData.pay.trim()
        case 'review': return formData.review.trim()
        default: return ''
      }
    }

    function updateCard() {
      if (!qrCode) return
      const data = buildQrData()
      isValid.value = data.length > 0
      const cornerType = (qrStyle.value === 'dots' || qrStyle.value === 'classy') ? 'dot' : 'extra-rounded'
      qrCode.update({
        data: isValid.value ? data : ' ',
        image: showQrLogo.value ? qrLogoSrc.value : '',
        imageOptions: { hideBackgroundDots: true, imageSize: 0.35, margin: 3 },
        dotsOptions: { type: qrStyle.value, color: qrDotColor.value },
        backgroundOptions: { color: qrBgColor.value },
        cornersSquareOptions: { type: cornerType, color: qrDotColor.value }
      })
    }

    function handleLogoUpload(e) {
      const file = e.target.files[0]
      if (!file) return
      const reader = new FileReader()
      reader.onload = ev => {
        customLogoUrl.value = ev.target.result
        logoLabel.value = file.name.length > 20 ? file.name.substring(0, 18) + '…' : file.name
      }
      reader.readAsDataURL(file)
    }

    function resetLogo() {
      customLogoUrl.value = DEFAULT_LOGO
      logoLabel.value = 'Subir imagen'
    }

    function handleIconUpload(e) {
      const file = e.target.files[0]
      if (!file) return
      const reader = new FileReader()
      reader.onload = ev => {
        customCardIconUrl.value = ev.target.result
        cardIconLabel.value = file.name.length > 16 ? file.name.substring(0, 14) + '…' : file.name
      }
      reader.readAsDataURL(file)
    }

    function resetIcon() {
      customCardIconUrl.value = null
      cardIconLabel.value = 'Subir ícono'
    }

    const downloadName = () => cardTitle.value || 'qr-neliel'

    function saveBlob(blob, filename) {
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      a.click()
      setTimeout(() => URL.revokeObjectURL(url), 1000)
    }

    const escXml = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&apos;' }[c]))

    // Arma un SVG vectorial de la tarjeta copiando las posiciones reales del DOM
    async function buildCardSvg() {
      const card = cardEl.value
      const box = card.getBoundingClientRect()
      const W = box.width
      const H = box.height
      const rel = el => {
        const r = el.getBoundingClientRect()
        return { x: r.left - box.left, y: r.top - box.top, w: r.width, h: r.height }
      }
      const textNode = el => {
        const r = rel(el)
        const cs = getComputedStyle(el)
        return `<text x="${W / 2}" y="${r.y + r.h / 2}" text-anchor="middle" dominant-baseline="central"` +
          ` font-family="${escXml(cs.fontFamily)}" font-size="${cs.fontSize}" font-weight="${cs.fontWeight}"` +
          ` letter-spacing="${cs.letterSpacing === 'normal' ? 0 : cs.letterSpacing}" fill="${cs.color}">${escXml(el.textContent.trim())}</text>`
      }
      const parts = []

      parts.push(`<defs><clipPath id="card-clip"><rect width="${W}" height="${H}" rx="24"/></clipPath>` +
        `<filter id="ring-shadow" x="-30%" y="-30%" width="160%" height="160%"><feDropShadow dx="0" dy="4" stdDeviation="5" flood-opacity="0.15"/></filter></defs>`)
      parts.push(`<rect x="0.5" y="0.5" width="${W - 1}" height="${H - 1}" rx="24" fill="#ffffff" stroke="rgba(0,0,0,0.06)"/>`)

      const header = card.querySelector('.qr-card-header')
      const h = rel(header)
      parts.push(`<rect x="${h.x}" y="${h.y}" width="${h.w}" height="${h.h}" fill="${headerColor.value}" clip-path="url(#card-clip)"/>`)

      const ring = rel(card.querySelector('.qr-icon-ring'))
      parts.push(`<circle cx="${ring.x + ring.w / 2}" cy="${ring.y + ring.h / 2}" r="${ring.w / 2}" fill="#ffffff" filter="url(#ring-shadow)"/>`)
      const icon = rel(card.querySelector('.qr-icon-img'))
      let iconHref = resolvedIconUrl.value
      if (!iconHref.startsWith('data:')) {
        try { iconHref = await toDataUrl(iconHref) } catch (e) { /* sin CORS: se deja la URL */ }
      }
      parts.push(`<image href="${escXml(iconHref)}" x="${icon.x}" y="${icon.y}" width="${icon.w}" height="${icon.h}" preserveAspectRatio="xMidYMid meet"/>`)

      parts.push(textNode(card.querySelector('.qr-card-title')))
      parts.push(textNode(card.querySelector('.qr-card-sub')))

      const f = rel(card.querySelector('.qr-frame'))
      parts.push(`<rect x="${f.x + 1}" y="${f.y + 1}" width="${f.w - 2}" height="${f.h - 2}" rx="16" fill="#ffffff" stroke="#cbd5e1" stroke-width="2" stroke-dasharray="6 4"/>`)

      const q = rel(qrCanvas.value)
      const qrBlob = await qrCode.getRawData('svg')
      const qrDoc = new DOMParser().parseFromString(await qrBlob.text(), 'image/svg+xml')
      const qrSvg = qrDoc.documentElement
      const qrSize = qrSvg.getAttribute('width') || q.w
      qrSvg.setAttribute('viewBox', `0 0 ${qrSize} ${qrSvg.getAttribute('height') || q.h}`)
      qrSvg.setAttribute('x', q.x)
      qrSvg.setAttribute('y', q.y)
      qrSvg.setAttribute('width', q.w)
      qrSvg.setAttribute('height', q.h)
      parts.push(new XMLSerializer().serializeToString(qrSvg))

      const overlay = card.querySelector('.qr-logo-overlay')
      if (overlay) {
        const o = rel(overlay)
        parts.push(`<rect x="${o.x}" y="${o.y}" width="${o.w}" height="${o.h}" rx="8" fill="#ffffff"/>`)
        parts.push(`<image href="${escXml(overlay.src)}" x="${o.x + 3}" y="${o.y + 3}" width="${o.w - 6}" height="${o.h - 6}" preserveAspectRatio="xMidYMid meet"/>`)
      }

      const nfcRow = card.querySelector('.qr-nfc-row')
      if (nfcRow) {
        const color = getComputedStyle(nfcRow).color
        const nfcIcon = nfcRow.querySelector('svg')
        const ni = rel(nfcIcon)
        const clone = nfcIcon.cloneNode(true)
        clone.removeAttribute('style')
        clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg')
        clone.setAttribute('x', ni.x)
        clone.setAttribute('y', ni.y)
        clone.setAttribute('width', ni.w)
        clone.setAttribute('height', ni.h)
        clone.setAttribute('color', color)
        parts.push(new XMLSerializer().serializeToString(clone))
        const label = nfcRow.querySelector('span')
        const l = rel(label)
        const cs = getComputedStyle(label)
        parts.push(`<text x="${l.x}" y="${l.y + l.h / 2}" dominant-baseline="central" font-family="${escXml(cs.fontFamily)}"` +
          ` font-size="${cs.fontSize}" font-weight="${cs.fontWeight}" fill="${color}">NFC</text>`)
      }

      return `<?xml version="1.0" encoding="UTF-8"?>\n` +
        `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="${W}" height="${H}" viewBox="0 0 ${W} ${H}">` +
        parts.join('') + '</svg>'
    }

    async function downloadPng() {
      if (!isValid.value || !qrCode) return
      if (qrOnly.value) {
        qrCode.download({ name: downloadName(), extension: 'png' })
        return
      }
      const { default: html2canvas } = await import('html2canvas')
      const canvas = await html2canvas(cardEl.value, { useCORS: true, scale: 3, backgroundColor: null })
      const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'))
      if (blob) saveBlob(blob, `${downloadName()}.png`)
    }

    async function downloadSvg() {
      if (!isValid.value || !qrCode) return
      if (qrOnly.value) {
        qrCode.download({ name: downloadName(), extension: 'svg' })
        return
      }
      const svg = await buildCardSvg()
      saveBlob(new Blob([svg], { type: 'image/svg+xml' }), `${downloadName()}.svg`)
    }

    function doPrint() {
      window.print()
    }

    // El header se compacta al hacer scroll
    const headerScrolled = ref(false)
    function onWindowScroll() { headerScrolled.value = window.scrollY > 20 }

    onMounted(() => {
      qrCode = new QRCodeStyling({
        width: 170,
        height: 170,
        dotsOptions: { type: 'dots', color: '#000000' },
        backgroundOptions: { color: '#ffffff' },
        cornersSquareOptions: { type: 'extra-rounded', color: '#000000' }
      })
      qrCode.append(qrCanvas.value)
      updateCard()
      loadDefaultLogo()
      onWindowScroll()
      window.addEventListener('scroll', onWindowScroll, { passive: true })
    })

    onBeforeUnmount(() => {
      window.removeEventListener('scroll', onWindowScroll)
    })

    watch(
      [headerColor, qrStyle, qrDotColor, qrBgColor, cardTitle, cardSubtitle,
       action, enableNfc, cardWidth, cardHeight, customLogoUrl, showQrLogo, customCardIconUrl, defaultLogoData, formData],
      updateCard,
      { deep: true }
    )

    return {
      ACTIONS,
      headerColor, qrStyle, qrDotColor, qrBgColor,
      cardTitle, cardSubtitle, action, enableNfc, qrOnly,
      cardWidth, cardHeight, customLogoUrl, showQrLogo, customCardIconUrl,
      isValid, logoLabel, cardIconLabel, qrCanvas, cardEl, formData,
      isLogoDataUrl, currentActionIcon, resolvedIconUrl,
      handleLogoUpload, resetLogo, handleIconUpload, resetIcon,
      downloadPng, downloadSvg, doPrint, headerScrolled
    }
  }
}
</script>

<style scoped>
/* ─── Página ─── */
.qr-page {
  min-height: 100vh;
  background: var(--c-bg, #faf9f7);
  display: flex;
  flex-direction: column;
}

/* ─── Encabezado: barra sticky que se encoge al hacer scroll ─── */
.qr-page-header {
  position: sticky;
  top: 0;
  z-index: 50;
  background: var(--c-primary, #003b4c);
  padding: 0.9rem 0;
  transition: padding 0.28s ease, background 0.28s ease, box-shadow 0.28s ease;
}
.qr-page-header--scrolled {
  background: rgba(0,59,76,0.92);
  backdrop-filter: blur(14px) saturate(1.4);
  -webkit-backdrop-filter: blur(14px) saturate(1.4);
  box-shadow: 0 4px 18px rgba(0,10,14,0.25);
  padding: 0.45rem 0;
}

.qr-page-header-inner {
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  align-items: center;
  gap: 14px;
}

.qr-back-btn {
  flex-shrink: 0;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: rgba(255,255,255,0.12);
  color: #fff;
  border: 1.5px solid rgba(255,255,255,0.3);
  font-size: 0.95rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s, border-color 0.2s;
}
.qr-back-btn:hover { background: rgba(255,255,255,0.22); border-color: rgba(255,255,255,0.5); }

.qr-page-title-area { flex: 1; min-width: 0; }

.qr-page-chip {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(255,255,255,0.15);
  color: var(--c-peach, #f0c2b2);
  border-radius: 999px;
  padding: 3px 12px;
  font-size: 0.7rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.qr-page-heading {
  font-size: 1.35rem;
  font-weight: 900;
  color: #fff;
  margin: 0;
  line-height: 1.2;
}

.qr-page-desc {
  color: rgba(255,255,255,0.7);
  font-size: 0.82rem;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 1.6em;
  transition: max-height 0.28s ease, opacity 0.2s ease;
}
.qr-page-header--scrolled .qr-page-desc { max-height: 0; opacity: 0; }

/* ─── Cuerpo de página ─── */
.qr-body-wrap {
  flex: 1;
  min-height: 0;
  padding: 0.75rem;
  display: flex;
  flex-direction: column;
}
.qr-page-body {
  flex: 1;
  min-height: 0;
  max-width: 1120px;
  margin: 0 auto;
  width: 100%;
  padding: 2rem;
  background: white;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 8px 32px rgba(0,0,0,0.10), 0 2px 8px rgba(0,0,0,0.05);
  overflow: hidden;
}

/* ─── Layout dos columnas ─── */
.qr-layout {
  display: grid;
  grid-template-columns: 420px 1fr;
  gap: 2.5rem;
  align-items: start;
}
.qr-layout > * { min-width: 0; }

/* ─── Panel configuración ─── */
.qr-panel {
  background: #fff;
  border-radius: 2rem;
  padding: 2rem 2.5rem;
  box-shadow: 0 20px 60px -10px rgba(0,0,0,0.25);
  border: 1px solid #e2e8f0;
  overflow-y: auto;
  max-height: 85vh;
  scrollbar-width: none;
  -ms-overflow-style: none;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  font-family: marine, 'Inter', sans-serif;
}
.qr-panel::-webkit-scrollbar { display: none; }

.qr-panel-title {
  font-size: 1.25rem;
  font-weight: 900;
  color: var(--c-primary, #003b4c);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 0 0 0.25rem;
}

/* ─── Bloques y filas ─── */
.qr-block {
  background: #f8fafc;
  border-radius: 1rem;
  padding: 1rem;
}

.qr-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.qr-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

/* ─── Labels ─── */
.qr-label {
  font-size: 0.65rem;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--c-primary, #003b4c);
}
.qr-label-muted { color: #94a3b8; }

/* ─── Inputs ─── */
.qr-input {
  width: 100%;
  padding: 8px 10px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.85rem;
  font-family: marine, 'Inter', sans-serif;
  color: #1a1a1a;
  box-sizing: border-box;
  transition: border-color 0.15s;
}
.qr-input:focus { outline: none; border-color: var(--c-primary, #003b4c); }
.qr-input-center { text-align: center; font-weight: 700; }

.qr-select {
  width: 100%;
  padding: 8px 10px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.8rem;
  font-family: marine, 'Inter', sans-serif;
  font-weight: 700;
  cursor: pointer;
}

.qr-color {
  width: 100%;
  height: 40px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  padding: 2px;
}

/* ─── Subida de archivo ─── */
.qr-file-row {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-top: 4px;
}

.qr-file-label {
  flex: 1;
  cursor: pointer;
  background: #fff;
  border: 1px dashed #cbd5e1;
  border-radius: 10px;
  padding: 8px 12px;
  font-size: 0.78rem;
  font-weight: 700;
  color: #64748b;
  text-align: center;
  transition: border-color 0.15s, color 0.15s;
  font-family: marine, 'Inter', sans-serif;
}
.qr-file-label:hover { border-color: var(--c-primary, #003b4c); color: var(--c-primary, #003b4c); }
.qr-file-label-sm { font-size: 0.7rem; padding: 5px 10px; }

.qr-file-hidden { display: none; }

.qr-reset-btn {
  background: none;
  border: none;
  font-size: 0.65rem;
  font-weight: 900;
  text-transform: uppercase;
  color: #94a3b8;
  cursor: pointer;
  white-space: nowrap;
  font-family: marine, 'Inter', sans-serif;
  transition: color 0.15s;
}
.qr-reset-btn:hover { color: #ef4444; }

/* ─── Selector de acción ─── */
.qr-action-select {
  width: 100%;
  padding: 14px 16px;
  background: var(--c-primary, #003b4c);
  color: #fff;
  border: none;
  border-radius: 12px;
  font-family: marine, 'Inter', sans-serif;
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
  margin-top: 4px;
}

.qr-action-icon-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 10px;
}

.qr-action-icon-preview {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  object-fit: contain;
  background: #f8fafc;
  padding: 4px;
  border: 1px solid #e2e8f0;
}

/* ─── Campos dinámicos ─── */
.qr-fields-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* ─── Checkbox ─── */
.qr-checkbox-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.75rem;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  cursor: pointer;
  padding: 6px 8px;
  background: #f8fafc;
  border-radius: 8px;
}
.qr-checkbox {
  width: 16px;
  height: 16px;
  accent-color: var(--c-primary, #003b4c);
  cursor: pointer;
}

.qr-nfc-toggle {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  background: #f8fafc;
  border-radius: 1rem;
  font-size: 0.65rem;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--c-primary, #003b4c);
  cursor: pointer;
}

/* ─── Preview ─── */
.qr-preview-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  min-height: 550px;
  padding: 2rem;
}

/* La tarjeta usa px fijos; si excede la pantalla, se desplaza horizontalmente */
.qr-card-scroll { max-width: 100%; overflow-x: auto; padding: 4px; }
.qr-card-scroll .qr-card { margin: 0 auto; }

.qr-card {
  background: #fff;
  border-radius: 1.5rem;
  border: 1px solid rgba(0,0,0,0.06);
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  box-shadow: 0 10px 30px -5px rgba(0,0,0,0.18);
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
  flex-shrink: 0;
}

/* Modo "Solo QR": sin diseño de tarjeta */
.qr-card--bare {
  width: auto;
  height: auto;
  background: transparent;
  border: none;
  box-shadow: none;
  border-radius: 0;
}
.qr-card--bare .qr-card-body { margin-top: 0; padding: 0; }
.qr-card--bare .qr-frame { border: none; padding: 0; }

.qr-card-header {
  width: 100%;
  height: 6rem;
  transition: background-color 0.3s;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

.qr-card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 1.5rem 2rem;
  margin-top: -3rem;
  position: relative;
}

.qr-icon-ring {
  width: 90px;
  height: 90px;
  background: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 4px solid #fff;
  box-shadow: 0 4px 12px -2px rgba(0,0,0,0.15);
  margin-bottom: 0.5rem;
  z-index: 10;
}
.qr-icon-img {
  width: 50px;
  height: 50px;
  object-fit: contain;
}

.qr-card-title {
  font-size: 1.35rem;
  font-weight: 800;
  color: #000;
  text-align: center;
  margin: 0.25rem 0 0;
  font-family: marine, 'Inter', sans-serif;
}
.qr-card-sub {
  font-size: 0.7rem;
  color: #94a3b8;
  font-weight: 700;
  margin-bottom: 1.25rem;
  letter-spacing: 0.15em;
  font-family: marine, 'Inter', sans-serif;
}

.qr-frame {
  background: #fff;
  padding: 0.75rem;
  border: 2px dashed #cbd5e1;
  border-radius: 1rem;
  position: relative;
}

.qr-warning {
  position: absolute;
  top: -10px;
  right: -10px;
  background: #ef4444;
  color: #fff;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  font-size: 13px;
  font-weight: 900;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 30;
}

.qr-logo-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 44px;
  height: 44px;
  background: #fff;
  padding: 3px;
  border-radius: 8px;
  object-fit: contain;
  z-index: 20;
}

.qr-nfc-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 1rem;
  font-size: 0.8rem;
  font-weight: 800;
  color: #cbd5e1;
  text-transform: uppercase;
  font-family: marine, 'Inter', sans-serif;
}

/* ─── Barra de acciones ─── */
.qr-action-bar {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
}

.qr-action-bar-label {
  font-size: 0.72rem;
  color: var(--c-text3, #7a7570);
  font-family: marine, 'Inter', sans-serif;
  text-align: center;
}

.qr-action-btns {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
}

.qr-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 999px;
  font-family: marine, 'Inter', sans-serif;
  font-size: 0.85rem;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s, opacity 0.2s, border-color 0.2s;
  white-space: nowrap;
}
.qr-action-btn:disabled { opacity: 0.38; cursor: not-allowed; }

.qr-action-btn--outline {
  background: #fff;
  color: var(--c-primary, #003b4c);
  border: 2px solid var(--c-primary, #003b4c);
}
.qr-action-btn--outline:not(:disabled):hover {
  background: var(--c-overlay, rgba(0,59,76,0.06));
}

.qr-action-btn--primary {
  background: var(--c-primary, #003b4c);
  color: #fff;
  border: 2px solid var(--c-primary, #003b4c);
}
.qr-action-btn--primary:not(:disabled):hover { background: #005570; border-color: #005570; }

/* ─── Responsive ─── */

/* Tablet 769–1023px: single-column, header stacks */
@media (max-width: 1023px) {
  .qr-layout { grid-template-columns: 1fr; }
  .qr-preview-wrap { position: static; min-height: 360px; padding: 1.5rem; }
  .qr-panel { max-height: none; overflow-y: visible; }
  .qr-action-btns { width: 100%; }
  .qr-action-btn { flex: 1; justify-content: center; }
}

/* Mobile ≤768px: release card height-lock so page scrolls naturally */
@media (max-width: 768px) {
  .qr-page-header { padding: 0.55rem 0; }
  .qr-page-header--scrolled { padding: 0.4rem 0; }
  .qr-page-heading { font-size: 1.05rem; }
  .qr-page-desc, .qr-page-chip { display: none; }
  .qr-back-btn { width: 38px; height: 38px; font-size: 0.85rem; }
  .qr-body-wrap { flex: none; padding: 0.5rem; }
  .qr-page-body { flex: none; overflow: visible; padding: 1.25rem; border-radius: 12px; }
  .qr-preview-wrap { min-height: 280px; padding: 1rem 0.25rem; }
  .qr-action-btns { flex-wrap: wrap; }
  /* 16px evita el auto-zoom de iOS al enfocar inputs */
  .qr-input, .qr-select, .qr-action-select { font-size: 16px; }
}

/* Small phones ≤480px */
@media (max-width: 480px) {
  .qr-page-header-inner { padding: 0 14px; }
  .qr-body-wrap { padding: 0.375rem; }
  .qr-page-body { padding: 0.875rem; border-radius: 10px; }
  .qr-panel { padding: 1.25rem 1.25rem; border-radius: 1.25rem; }
  .qr-action-btn { font-size: 0.8rem; padding: 9px 14px; }
  .qr-action-btn span { display: none; }
}

/* ─── Impresión ─── */
@media print {
  .qr-page { padding-top: 0 !important; background: #fff !important; }
  .qr-page-header { display: none !important; }
  .qr-page-body { padding: 0 !important; max-width: none !important; }
  .qr-panel { display: none !important; }
  .qr-action-bar { display: none !important; }
  .qr-layout { display: block; }
  .qr-preview-wrap { position: static; padding: 0; min-height: auto; display: flex; justify-content: center; }
  .qr-card-scroll { overflow: visible !important; padding: 0 !important; }
  .qr-card { box-shadow: none !important; border: 1px solid #ccc !important; }
  .qr-card--bare { border: none !important; }
}
</style>
